<template lang="pug">
  .player-wrapper
    .player-content
      youtube(
        :video-id="videoId"
        :player-vars="mergedVars"
        :mute="mute"
        @ready="initPlayer"
        @ended="hidePlayer"
        @playing="showPlayer"
        :class="{show: isPlaying}"
        player-width="100%"
        player-height="auto")

</template>

<script>
import { getIdFromURL } from 'vue-youtube-embed'

export default {
  props: {
    videoUrl: {
      type: String,
      required: true
    },
    mute: {
      type: Boolean,
      default: true
    },
    playerVars: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      videoId: getIdFromURL(this.videoUrl),
      isPlaying: false,
      player: undefined,
      mergedVars: {
        ...{
          autoplay: 0,
          loop: 1,
          modestbranding: 1,
          rel: 0,
          showinfo: 1,
          controls: 1,
          playlist: getIdFromURL(this.videoUrl),
          iv_load_policy: 3
        },
        ...this.playerVars
      }
    }
  },
  methods: {
    initPlayer (event) {
      this.player = event.target
      this.player.setPlaybackQuality('hd1080')
    },
    showPlayer () {
      this.isPlaying = true
    },
    hidePlayer () {
      this.isPlaying = false
    }
  }
}
</script>
